module.exports = __webpack_public_path__ + "static/media/barbara1.eb41d184.mp3";